/* InvoicePrint.tsx */
import { Grid, makeStyles, PropTypes, Typography } from '@material-ui/core';
import FlexBox from 'components/FlexBox';
import { format } from 'date-fns';
import React from 'react';
import NumberFormat from 'components/NumberFormat';
import './invoicePrint.css';
import Logo from 'images/NewLogo.jpg';

interface Props {
  invoiceReportPrint: InvoiceReportPrint;
}

const useStyles = makeStyles({
  invoiceList: {
    color: '#000000',
    fontSize: '12px',
    margin: 0,
    padding: '2px'
  },
  line: {
    border: '1px solid #000000',
    margin: 0,
    padding: 0
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px'
  },
  th: {
    border: '1px solid #000000',
    padding: '4px',
    textAlign: 'center',
    backgroundColor: '#f2f2f2',
    color: '#000000',
    fontSize: '10px'
  },
  td: {
    border: '1px solid #000000',
    padding: '2px',
    textAlign: 'left',
    color: '#000000',
    fontSize: '8px'
  },
  totalRow: {
    fontWeight: 'bold',
    color: '#000000',
    fontSize: '8px'
  },
  colLarge: {
    width: '25%', // Ukuran khusus untuk kolom NAMA
    textAlign: 'left'
  },
  colOther: {
    width: '10%', // Ukuran untuk kolom lain, disesuaikan agar total 100%
    textAlign: 'left'
  }
});

const GridFlex = {
  small: 0.6,
  normal: 1,
  large: 1.5
};

const InvoicePrint = ({ invoiceReportPrint }: Props) => {
  const classes = useStyles();

  const getTotal = () => {
    const sumTotal = invoiceReportPrint.partners.map(partner =>
      partner.invoices.reduce((total, item) => {
        if (item.status.includes('Return')) {
          return total - (item.totalPrice - item.totalPay);
        }
        return total + (item.totalPrice - item.totalPay);
      }, 0)
    );

    const totalFinal = sumTotal.reduce((total, curr) => total + curr, 0);
    return totalFinal;
  };

  const getTotalPartner = (index: number) => {
    const sumTotal = invoiceReportPrint.partners[index].invoices.reduce((total, item) => {
      if (item.status.includes('Return')) {
        return total - (item.totalPrice - item.totalPay);
      }
      return total + (item.totalPrice - item.totalPay);
    }, 0);

    return sumTotal;
  };

  return (
    <Grid xs={12} container justify='center' style={{ margin: 0, padding: 0 }}>
      <FlexBox xs={12} container rowGap={1} direction='row' style={{ margin: 0, padding: 0, gap: 0, marginRight: 40, marginTop: 40 }}>
        <Grid xs={12}>
          <Typography variant='h5' style={{ fontSize: '12px', fontWeight: 'bold', margin: 0, color: '#000000' }} align='center'>
            LAPORAN - SISA PIUTANG - LANGGANAN
          </Typography>
          <Typography variant='h6' style={{ fontSize: '12px', fontWeight: 'bold', margin: 0, color: '#000000' }} align='center'>
            (SEMUA NOTA)
          </Typography>
          <Typography variant='h6' style={{ fontSize: '12px', fontWeight: 'bold', margin: 0, color: '#000000' }} align='center'>
            Per: {format(new Date(invoiceReportPrint.selectInvoiceId?.date || new Date()), 'dd-MM-yyyy')}
          </Typography>
        </Grid>

        <FlexBox container rowGap={1} style={{ gap: 0 }}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th className={classes.th} style={{ width: '12%' }}>
                  NAMA
                </th>
                <th className={classes.th} style={{ width: '10%' }}>
                  TGL
                </th>
                <th className={classes.th} style={{ width: '10%' }}>
                  NOTA
                </th>
                <th className={classes.th} style={{ width: '12%' }}>
                  JUMLAH SISA
                </th>
                <th className={classes.th} style={{ width: '12%' }}>
                  NO RTR
                </th>
                <th className={classes.th} style={{ width: '12%' }}>
                  RP RTR
                </th>
                <th className={classes.th} style={{ width: '12%' }}>
                  BAYAR
                </th>
                <th className={classes.th} style={{ width: '10%' }}>
                  SISA
                </th>
                <th className={classes.th} style={{ width: '10%' }}>
                  KET
                </th>
              </tr>
            </thead>
            <tbody>
              {invoiceReportPrint.partners.map((partner, partnerKey) => (
                <React.Fragment key={partnerKey}>
                  {partner.invoices.map((invoice, invoiceKey) => (
                    <tr key={`${partnerKey}-${invoiceKey}`}>
                      <td className={`${classes.td}`}>{partner.partnerName}</td>
                      <td className={classes.td}>{invoice.orderDate ? format(new Date(invoice.orderDate.split(' ')[0]), 'dd MMM yyyy') : '-'}</td>
                      <td className={classes.td}>{`#${invoice.invoiceNumber}`}</td>
                      <td className={classes.td}>
                        <NumberFormat
                          value={invoice.totalPrice - invoice.totalPay}
                          prefix={invoice.status.includes('Return') ? '(Rp' : 'Rp'}
                          suffix={invoice.status.includes('Return') ? ')' : ''}
                          thousandSeparator={true}
                          displayType='text'
                        />
                      </td>
                      <td className={classes.td}>
                        {Array.isArray(invoice.noReturn) && invoice.noReturn.length > 0
                          ? invoice.noReturn.map((val, i) => (
                              <React.Fragment key={i}>
                                {val}
                                <br />
                              </React.Fragment>
                            ))
                          : ''}
                      </td>
                      <td className={classes.td}>
                        {Array.isArray(invoice.rpReturn) && invoice.rpReturn.length > 0
                          ? invoice.rpReturn.map((val, i) => (
                              <React.Fragment key={i}>
                                <NumberFormat value={val} prefix='Rp' thousandSeparator={true} displayType='text' />
                                <br />
                              </React.Fragment>
                            ))
                          : ''}
                      </td>
                      <td className={classes.td}>
                        {Array.isArray(invoice.paymentInv)
                          ? invoice.paymentInv.map((val, i) => (
                              <React.Fragment key={i}>
                                <NumberFormat value={val} prefix='Rp' thousandSeparator={true} displayType='text' />
                                <br />
                              </React.Fragment>
                            ))
                          : '' // <NumberFormat value={invoice.paymentInv || 0} prefix='Rp' thousandSeparator={true} displayType='text' />
                        }
                      </td>
                      <td className={classes.td}>
                        {'remainingInv' in invoice && (
                          <NumberFormat value={invoice.remainingInv} prefix='Rp' thousandSeparator={true} displayType='text' />
                        )}
                      </td>
                      <td className={classes.td}>
                        {Array.isArray(invoice.desc)
                          ? invoice.desc.map((val, i) => (
                              <React.Fragment key={i}>
                                {val || '-'}
                                <br />
                              </React.Fragment>
                            ))
                          : invoice.desc || ''}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={3} className={classes.td} style={{ textAlign: 'right' }}>
                      TOTAL {partner.partnerName}
                    </td>
                    <td className={`${classes.td} ${classes.totalRow}`}>
                      <NumberFormat value={getTotalPartner(partnerKey)} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                    </td>
                    <td colSpan={5} className={classes.td}></td>
                  </tr>
                </React.Fragment>
              ))}
              <tr>
                <td colSpan={3} className={classes.td} style={{ textAlign: 'right' }}>
                  TOTAL SEMUA
                </td>
                <td className={`${classes.td} ${classes.totalRow}`}>
                  <NumberFormat value={getTotal()} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                </td>
                <td colSpan={5} className={classes.td}></td>
              </tr>
            </tbody>
          </table>
        </FlexBox>
      </FlexBox>
    </Grid>
  );
};

export default InvoicePrint;
